module.exports = __webpack_public_path__ + "img/news-img2.6f087eb6.jpg";